import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import StressLogo from '../Assets/stresslogo_small.png';

const getShortName = (fullName) => {
  if (!fullName) return '';
  const nameParts = fullName.split(' ');
  const firstName = nameParts[0];
  const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) + '.' : '';
  return `${firstName} ${lastInitial}`;
};

const Header = ({ 
  userName, 
  userRole, 
  handleLogin, 
  handleLogout, 
  isAuthenticated, 
  toggleMenu, 
  isMenuOpen 
}) => {
  const shortName = getShortName(userName);
  // Only display the menu if a role is assigned and it is not "No Access"
  const showMenu = userRole && userRole !== "No Access";

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" className="logo-link">
          <img src={StressLogo} alt="Logo" />
          <span className="title">STRESS LAB DB</span>
        </Link>
      </div>
      <div className="user-info">
        {isAuthenticated ? (
          <>
            {userRole && <p className="short-name">{shortName} | Role: {userRole}</p>}
            {showMenu ? (
              <div className="hamburger" onClick={toggleMenu}>
                <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
                <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
                <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
              </div>
            ) : (
              <button onClick={handleLogout} className="logout-button">
                Logout
              </button>
            )}
          </>
        ) : (
          <button onClick={handleLogin}>Login</button>
        )}
      </div>
    </header>
  );
};

export default Header;
